import React from 'react';
import PropTypes from 'prop-types';
import { FaPhone, FaCircle } from 'react-icons/fa';

const CallBtn = ({ sanity, page }) => {
  const { colors } = sanity;
  const { gbp } = page;
  return (
    <a
      href={`tel:${gbp?.phone}`}
      className="fixed bottom-3 right-2 z-50 lg:hidden"
      style={{
        filter: 'drop-shadow(3px 3px 5px rgba(0, 0, 0, 0.5))',
        color: colors?.accent?.default,
      }}
    >
      <FaCircle
        size={64}
        color={colors?.primary?.dark}
        stroke={colors?.neutral?.white}
        strokeWidth="10px"
        className=""
      />
      <FaPhone
        size={32}
        color={colors?.accent?.default}
        stroke={colors?.neutral?.white}
        strokeWidth="10px"
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform"
      />
    </a>
  );
};

CallBtn.defaultProps = {
  sanity: {},
  page: {},
};

CallBtn.propTypes = {
  sanity: PropTypes.object,
  page: PropTypes.object,
};

export { CallBtn };
